import { memo } from 'react';
import avatars from '../config/avatars';

type IncompleteUser = {
  key: string;
  ArtworkComponent: (typeof avatars)[keyof typeof avatars]['ArtworkComponent'];
  handle?: string;
  avatarBackgroundHex?: string | null;
};

export let INCOMPLETE_ITEMS_PER_ROW = 3;
export let INCOMPLETE_AVATAR_SIZE = 56;
export let INCOMPLETE_ROW_OFFSET = 12;
export let INCOMPLETE_HANDLE_HEIGHT = 22;
export let INCOMPLETE_GAP = 16;
export let INCOMPLETE_PADDING_TOP = 16;
export let INCOMPLETE_ROW_HEIGHT = INCOMPLETE_AVATAR_SIZE + INCOMPLETE_HANDLE_HEIGHT + INCOMPLETE_GAP;

export let getIncompleteClusterHeight = (userCount: number) => {
  let rows = Math.ceil(userCount / INCOMPLETE_ITEMS_PER_ROW);
  return INCOMPLETE_PADDING_TOP + rows * INCOMPLETE_ROW_HEIGHT;
};

export let IncompleteAvatarGrid = memo(({ users }: { users: IncompleteUser[] }) => (
  <div
    className="grid justify-center px-6"
    style={{
      paddingTop: INCOMPLETE_PADDING_TOP,
      gap: INCOMPLETE_GAP,
      gridTemplateColumns: `repeat(${Math.min(users.length, INCOMPLETE_ITEMS_PER_ROW)}, ${INCOMPLETE_AVATAR_SIZE}px)`,
    }}
  >
    {users.map(({ key, ArtworkComponent, handle, avatarBackgroundHex }, i) => {
      let row = Math.floor(i / INCOMPLETE_ITEMS_PER_ROW);
      let offset = users.length < INCOMPLETE_ITEMS_PER_ROW ? 0 : row % 2 === 0 ? INCOMPLETE_ROW_OFFSET : -INCOMPLETE_ROW_OFFSET;
      return (
        <div key={key} className="flex flex-col items-center" style={{ transform: `translateX(${offset}px)` }}>
          <ArtworkComponent
            style={{ width: INCOMPLETE_AVATAR_SIZE, height: INCOMPLETE_AVATAR_SIZE }}
            backgroundColor={avatarBackgroundHex || undefined}
          />
          <div className="__handle mt-1.5 w-full truncate text-center text-xs text-purple-300">
            {handle}
          </div>
        </div>
      );
    })}
  </div>
));

